/* IDEAL ROUND (copy only, never live; kit/IDEAL-BRIEF.md): the ideal layer's behaviour on the product page.
   Countdowns, bundle tiers (the button shows the tier total), stock line + live viewers per colour, recent-purchase
   toasts, reviews filters, and the ideal cart drawer (the kit's buy buttons, the final CTA and the header bag open it).
   Config + the countdown function come from snippets/ph-iconf (inline, generated by kit/build.py).
   window.__phCartDemo = true: the drawer works on a demo cart and never writes to the real cart (screenshots).
   window.__phNoToast = true: no toasts (first-screen screenshots). */
(function () {
  'use strict';
  var P = window.phIdeal = window.phIdeal || {};
  if (P.ready) return;
  P.ready = true;
  var doc = document, root = doc.documentElement;
  var W = window.wpPdp = window.wpPdp || {};
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function jsonOf(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var I = jsonOf($('#ph-ijson')) || {};
  var T = (P.cfg && P.cfg.texts) || {};
  P.icons = {
    check: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    plus: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>',
    minus: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 12h13"/></svg>'
  };
  var PR = jsonOf($('[data-ph-prices]')) || { v: {}, pct: 65, bundle: 15 };
  var demo = !!window.__phCartDemo;
  var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var handle = (doc.querySelector('[data-wp-handle]') || {}).getAttribute ? doc.querySelector('[data-wp-handle]').getAttribute('data-wp-handle') : '';
  var bag = (I.bags && I.bags[handle]) || {};

  /* ---------- money (formatted like the theme: separators and symbol from a rendered sample) ---------- */
  var sample = (P.cfg && P.cfg.moneySample) || '€1.234,56';
  var sep = /1([.,'\s  ]?)234([.,])56/.exec(sample) || [null, '.', ','];
  function money(c) {
    c = Math.round(c);
    var neg = c < 0; c = Math.abs(c);
    var whole = Math.floor(c / 100), cents = c % 100;
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, sep[1] || '');
    if (cents) s += sep[2] + (cents < 10 ? '0' : '') + cents;
    return (neg ? '−' : '') + sample.replace(/1[.,'\s  ]?234[.,]56/, s);
  }
  function pin() { try { return !!(P.isPin && P.isPin()); } catch (e) { return false; } }
  function worldPrice(m) { return pin() ? Math.floor(m * (PR.pct || 65) / 100) : m; }
  function whole(c) { return Math.floor(c / 100) * 100; }
  function parsePrice(t) { var d = String(t || '').replace(/[^\d]/g, ''); return d ? +d : 0; }

  function fixMoney(el) {
    if (!el || !/^\D/.test(sample)) return; // only where the shop puts the symbol first (€117)
    el.innerHTML = el.innerHTML.replace(/(\d+(?:,\d{2})?)\s?€/g, '€$1');
  }
  $$('.ph-addon b, .ph-addon small, .ph-bonus span, .ph-tier__l small').forEach(fixMoney);

  /* ---------- gallery: the peek carousel (D6) pages by slide, not by the track width ---------- */
  (function () {
    var gal = $('[data-wp-gal]'), track = gal && $('[data-wp-track]', gal); if (!track) return;
    var thumbs = $('[data-wp-thumbs]', gal), prevB = $('[data-wp-prev]', gal), nextB = $('[data-wp-next]', gal);
    function ss() { return Array.prototype.filter.call(track.children, function (x) { return !x.hidden; }); }
    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function pos(el) { return el.offsetLeft - track.offsetLeft - pad(); }
    function idx() { var s = ss(), best = 0, d = 1e9; s.forEach(function (el, i) { var dd = Math.abs(pos(el) - track.scrollLeft); if (dd < d) { d = dd; best = i; } }); return best; }
    function go(i) { var s = ss(); i = Math.max(0, Math.min(s.length - 1, i)); if (s[i]) track.scrollTo({ left: pos(s[i]), behavior: 'smooth' }); }
    function mark() {
      var s = ss(), i = idx(), id = s[i] && s[i].getAttribute('data-m');
      if (thumbs) $$('.wp-gal__thumb', thumbs).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-m') === id ? 'true' : 'false'); });
      if (prevB) prevB.disabled = i <= 0;
      if (nextB) nextB.disabled = i >= s.length - 1;
    }
    gal.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-wp-prev], [data-wp-next], .wp-gal__thumb'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      if (b.hasAttribute('data-wp-prev')) go(idx() - 1);
      else if (b.hasAttribute('data-wp-next')) go(idx() + 1);
      else { var s = ss(), id = b.getAttribute('data-m'); for (var i = 0; i < s.length; i++) if (s[i].getAttribute('data-m') === id) { go(i); break; } }
    }, true);
    var q = false;
    track.addEventListener('scroll', function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; mark(); }); }, { passive: true });
    doc.addEventListener('wp:variant', function () { setTimeout(mark, 30); });
    mark();
  })();

  /* ---------- countdowns ---------- */
  setInterval(function () { if (P.tick) P.tick(); }, 1000);

  /* ---------- the current variant (the kit's boot owns it) ---------- */
  function curId() { return String(W.cur || (doc.querySelector('form[data-wp-form] [name="id"]') || {}).value || ''); }
  function curV() { return PR.v[curId()] || null; } // [main cents, available, colour, img, title]

  /* ---------- bundle tiers: the button and the sticky show the chosen tier's total ---------- */
  var offer = $('[data-ph-offer]');
  function tier() { var r = offer && offer.querySelector('input[type=radio]:checked'); return r ? r.value : 'one'; }
  /* ---------- mix & match: "2 bags" = any two bags (Tasche 1 / Tasche 2, another colour or another style) ---------- */
  var SB = PR.second || { mode: 'pct', cents: 0 };
  var mixEl = offer && offer.querySelector('[data-ph-mix]'), chooser = offer && offer.querySelector('[data-ph-chooser]');
  var mix = { b2: null };
  // the pickers sit right under the "2 bags" tier they belong to
  (function () { var two = offer && offer.querySelector('[data-ph-tier="two"]'); if (two && mixEl) two.parentNode.insertBefore(mixEl, two.nextSibling); })();
  function colours() { var out = []; Object.keys(PR.v).forEach(function (id) { var c = PR.v[id][2]; if (out.indexOf(c) < 0) out.push(c); }); return out; }
  function variantFor(colour, likeId) {
    // the variant of this bag in that colour, keeping bag 1's other options (size) when that one is in stock
    var like = W.byId ? W.byId(likeId || curId()) : null, best = null;
    Object.keys(PR.v).forEach(function (id) {
      var x = PR.v[id]; if (x[2] !== colour) return;
      var kv = W.byId ? W.byId(id) : null, same = like && kv && kv.o.slice(1).join('|') === like.o.slice(1).join('|');
      if (!best || (same && x[1]) || (!PR.v[best][1] && x[1])) { if (!best || same || !PR.v[best][1]) best = id; }
    });
    return best;
  }
  function own(id) { var x = PR.v[id]; return x ? { id: id, m: x[0], c: x[2], t: PR.title || '', img: x[3], other: false } : null; }
  function defaultB2() {
    var v = curV(); if (!v) return null;
    var cs = colours(), k = cs.indexOf(v[2]);
    for (var i = 1; i <= cs.length; i++) {
      var c = cs[(k + i) % cs.length]; if (c === v[2]) continue;
      var id = variantFor(c); if (id && PR.v[id][1]) return own(id);
    }
    return own(curId());
  }
  function b2() {
    if (!mix.b2 || (!mix.b2.other && PR.v[mix.b2.id] && PR.v[mix.b2.id][2] === (curV() || [])[2] && colours().length > 1)) mix.b2 = defaultB2();
    return mix.b2;
  }
  function second(sum, w2) { return SB.mode === 'fixed' ? Math.max(0, sum - (SB.cents || 0)) : whole(sum * (1 - (PR.bundle || 15) / 100)); }
  function totals(t) {
    var v = curV(); if (!v) return null;
    var m = v[0], keep = 1 - (PR.bundle || 15) / 100, pct = (PR.pct || 65) / 100;
    if (t === 'two') {
      var o = b2() || own(curId()), mm = m + o.m, ww = Math.floor(m * pct) + Math.floor(o.m * pct);
      return { nowM: second(mm), wasM: mm, nowW: second(ww), wasW: ww };
    }
    if (t === 'set') {
      var c = PR.set ? PR.set.m : m, cw = Math.floor(c * pct), w = Math.floor(m * pct);
      return { nowM: whole((m + c) * keep), wasM: whole(m + c), nowW: whole((w + cw) * keep), wasW: whole(w + cw) };
    }
    return { nowM: m, wasM: 0, nowW: Math.floor(m * pct), wasW: m };
  }
  function paintMix() {
    if (!mixEl) return;
    var on = tier() === 'two', v = curV(), o = b2();
    mixEl.hidden = !on; if (!on || !v || !o) return;
    var c1 = mixEl.querySelector('[data-ph-mix-c="1"]'), c2 = mixEl.querySelector('[data-ph-mix-c="2"]'), t2 = mixEl.querySelector('[data-ph-mix-t2]');
    if (c1) c1.textContent = v[2];
    if (c2) c2.textContent = o.c;
    if (t2) t2.textContent = o.other ? o.t + ' · ' : '';
    $$('[data-ph-mix-pick="1"]', mixEl).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-c') === v[2]); });
    $$('[data-ph-mix-pick="2"]', mixEl).forEach(function (b) { b.classList.toggle('is-on', !o.other && b.getAttribute('data-c') === o.c); });
    var os = mixEl.querySelector('[data-ph-mix-osel]'), sw2 = mixEl.querySelector('[data-ph-mix-sw2]');
    if (os) {
      var src = o.other && chooser ? chooser.querySelector('[data-ph-ch-pick][data-id="' + o.id + '"]') : null;
      os.innerHTML = src ? src.parentNode.innerHTML : '';
      $$('[data-ph-ch-pick]', os).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-id') === String(o.id)); });
      os.hidden = !src; os.className = src ? 'ph-mix__sw' : 'ph-mix__other-sel';
    }
    if (sw2) sw2.hidden = !!o.other;
  }
  function paintTiers() {
    if (!curV() || !offer) return;
    $$('[data-ph-tier]', offer).forEach(function (lab) {
      var x = totals(lab.getAttribute('data-ph-tier')); if (!x) return;
      var set = function (sel, val) { var el = lab.querySelector(sel); if (el) el.textContent = money(val); };
      set('[data-ph-tn="w"]', x.nowW); set('[data-ph-tn="m"]', x.nowM); set('[data-ph-tw="w"]', x.wasW); set('[data-ph-tw="m"]', x.wasM);
      lab.classList.toggle('is-on', !!(lab.querySelector('input') || {}).checked);
    });
    paintMix(); paintButton();
  }
  function paintButton() {
    var x = totals(tier()); if (!x || !offer) return;
    $$('[data-wp-buy] [data-wp-p="w"], [data-wp-sticky] [data-wp-p="w"]').forEach(function (el) { el.textContent = money(x.nowW); });
    $$('[data-wp-buy] [data-wp-p="m"], [data-wp-sticky] [data-wp-p="m"]').forEach(function (el) { el.textContent = money(x.nowM); });
    paintStickyTier();
    // the kit drops the "· 3 Farben" count when the sticky name no longer fits (it listens to resize)
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }
  function paintStickyTier() {
    var nm = $('.wp-sticky__name'); if (!nm) return;
    var t = tier(), lab = offer && offer.querySelector('[data-ph-tier="' + t + '"] .ph-tier__l b'), txt = '';
    if (t !== 'one' && lab) {
      var L = lab.textContent.trim().split(' · ')[0], m2 = /(\d+)\s+(\S+)/.exec(L), w = L.split(/\s+/);
      txt = t === 'two' && m2 ? m2[1] + ' ' + m2[2] : (w.length > 2 ? w[0] + ' + ' + w[w.length - 1] : L);
    }
    var sp = nm.querySelector('.ph-sticky-tier');
    if (!sp) { sp = doc.createElement('span'); sp.className = 'ph-sticky-tier'; nm.insertBefore(sp, nm.firstChild); }
    sp.textContent = txt ? txt + ' · ' : '';
    nm.classList.toggle('ph-has-tier', !!txt);
  }
  if (offer) offer.addEventListener('change', paintTiers);
  if (offer) offer.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var p1 = t.closest('[data-ph-mix-pick="1"]');
    if (p1) { e.preventDefault(); var id = variantFor(p1.getAttribute('data-c')); var kv = id && W.byId ? W.byId(id) : null; if (kv && W.apply) W.apply(kv, { from: 'mix' }); return; }
    var p2 = t.closest('[data-ph-mix-pick="2"]');
    if (p2) { e.preventDefault(); var id2 = variantFor(p2.getAttribute('data-c')); if (id2) { mix.b2 = own(id2); paintTiers(); } return; }
    if (t.closest('[data-ph-mix-other]')) { e.preventDefault(); if (chooser) { chooser.hidden = false; root.classList.add('ph-cart-open'); } return; }
    if (t.closest('[data-ph-chooser-close]')) { e.preventDefault(); if (chooser) { chooser.hidden = true; root.classList.remove('ph-cart-open'); } return; }
    var cp = t.closest('[data-ph-ch-pick]');
    if (cp) {
      e.preventDefault();
      mix.b2 = PR.v[cp.getAttribute('data-id')] ? own(cp.getAttribute('data-id')) : { id: cp.getAttribute('data-id'), m: +cp.getAttribute('data-m'), c: cp.getAttribute('data-c'), t: cp.getAttribute('data-t'), img: cp.getAttribute('data-img'), other: true };
      if (chooser) { chooser.hidden = true; root.classList.remove('ph-cart-open'); }
      paintTiers();
    }
  });
  if (chooser) {
    doc.body.appendChild(chooser);
    chooser.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('[data-ph-chooser-close]')) { e.preventDefault(); chooser.hidden = true; root.classList.remove('ph-cart-open'); return; }
      var cp = t.closest('[data-ph-ch-pick]'); if (!cp) return;
      e.preventDefault();
      mix.b2 = PR.v[cp.getAttribute('data-id')] ? own(cp.getAttribute('data-id')) : { id: cp.getAttribute('data-id'), m: +cp.getAttribute('data-m'), c: cp.getAttribute('data-c'), t: cp.getAttribute('data-t'), img: cp.getAttribute('data-img'), other: true };
      chooser.hidden = true; root.classList.remove('ph-cart-open');
      paintTiers();
    });
  }
  P.mix = mix;

  /* ---------- stock line, viewers, savings ---------- */
  function hash(s) { var h = 0; s = String(s); for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return Math.abs(h); }
  function paintStock() {
    var v = curV(); if (!v) return;
    var col = v[2], n = bag.stock && bag.stock[col] != null ? bag.stock[col] : (bag.stock_en && bag.stock_en[col] != null ? bag.stock_en[col] : 2 + hash(handle + col) % 5);
    $$('[data-ph-stock]').forEach(function (line) {
      var t = line.querySelector('[data-ph-stock-t]'); if (!t) return;
      var tpl = (+n === 0 && line.getAttribute('data-out')) ? line.getAttribute('data-out') : line.getAttribute('data-tpl') || '';
      t.innerHTML = tpl.replace('{n}', '<b data-ph-stock-n>' + n + '</b>').replace('{colour}', '<b data-ph-stock-c>' + esc(col) + '</b>');
    });
    var m = v[0], w = Math.floor(m * (PR.pct || 65) / 100);
    $$('[data-ph-save]').forEach(function (el) { el.textContent = money(m - w); });
  }
  var viewers = $('[data-ph-viewers]');
  if (viewers) {
    var vn = +viewers.textContent || 18;
    (function drift() {
      setTimeout(function () { vn = Math.max(9, Math.min(41, vn + (Math.random() < .5 ? -1 : 1) * (1 + Math.floor(Math.random() * 3)))); viewers.textContent = vn; drift(); }, 6000 + Math.random() * 5000);
    })();
  }
  doc.addEventListener('wp:variant', function () { paintTiers(); paintStock(); if (window.phCart && phCart.isOpen && phCart.isOpen()) phCart.render(); });
  paintTiers(); paintStock();

  /* ---------- reviews: filters (all / photos / stars) + 6 more per tap ---------- */
  $$('[data-ph-rv]').forEach(function (box) {
    var list = $$('.ph-irv__item', box), more = $('[data-ph-rv-more]', box), f = 'all', shown = 6;
    function apply() {
      var n = 0;
      list.forEach(function (it) {
        var ok = f === 'all' || (f === 'photo' ? it.getAttribute('data-photo') === '1' : it.getAttribute('data-stars') === f);
        it.hidden = !ok || ++n > shown;
      });
      if (more) more.hidden = n <= shown;
      $$('.ph-chip', box).forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-ph-rvf') === f); });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ph-rvf]');
      if (b) { f = b.getAttribute('data-ph-rvf'); shown = 6; apply(); return; }
      if (e.target.closest && e.target.closest('[data-ph-rv-more]')) { shown += 6; apply(); }
    });
  });

  /* ---------- buy: the chosen tier goes into the store's one drawer (snippets/ph-cart-drawer, assets/ph-cart.js) ---------- */
  function otherColour() {
    var v = curV(), out = null;
    Object.keys(PR.v).some(function (id) { var x = PR.v[id]; if (x[1] && v && x[2] !== v[2]) { out = { id: id, x: x }; return true; } return false; });
    return out;
  }
  function buyLines() {
    var id = curId(), v = curV(); if (!v) return [];
    var base = { id: id, m: v[0], title: PR.title || '', v: v[4], img: v[3] };
    var t = tier(), lines = [];
    if (t === 'two') {
      var o = b2() || own(id);
      if (String(o.id) === String(id)) lines.push(Object.assign({}, base, { qty: 2 }));
      else lines.push(Object.assign({}, base, { qty: 1 }), { id: o.id, qty: 1, m: o.m, title: o.other ? o.t : (PR.title || ''), v: o.other ? o.c : (PR.v[o.id] || [])[4] || o.c, img: o.img });
    }
    else if (t === 'set') {
      lines.push(Object.assign({}, base, { qty: 1 }));
      if (PR.set) lines.push({ id: PR.set.id || 'set-fictive', qty: 1, m: PR.set.m, title: PR.set.title, v: '', img: PR.set.img || '', fictive: !PR.set.id });
      else { var o2 = otherColour(); if (o2) lines.push({ id: o2.id, qty: 1, m: o2.x[0], title: PR.title || '', v: o2.x[4], img: o2.x[3] }); else lines[0].qty = 2; }
    } else lines.push(Object.assign({}, base, { qty: 1 }));
    return lines;
  }
  function buy() {
    var lines = buyLines(); if (!lines.length) return;
    var ad = offer && offer.querySelector('[data-ph-addon]'), attrs = null;
    if (ad && ad.checked) attrs = { 'Add-on': ad.value };
    if (window.phCart && phCart.add) phCart.add(lines, attrs);
  }
  // on the product page the drawer's upsell may offer this bag in another colour (after the set item)
  P.upsellAlt = function (items) {
    var o = otherColour(); if (!o) return null;
    if (items.some(function (x) { return String(x.id) === String(o.id); })) return null;
    return { id: o.id, m: o.x[0], title: PR.title || '', v: o.x[2], img: o.x[3] };
  };
  P.nl = !!PR.nl;
  // the kit's buy (form submit, sticky button) and the final CTA go to the drawer on the ideal template
  window.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[data-wp-form]')) return;
    e.preventDefault(); e.stopPropagation(); buy();
  }, true);
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var b = t.closest('[data-wp-sticky-btn], [data-ph-buy]');
    if (b && !b.disabled) { e.preventDefault(); e.stopPropagation(); buy(); }
  }, true);
  P.buy = buy;
})();
